import { Controller } from "@hotwired/stimulus"

// Adds an `is-stuck` class to the element while it is pinned by `position: sticky`.
// A 1px sentinel is inserted just above the element; once it scrolls past the
// element's sticky offset, the element is stuck. Used to let the reviews search
// bar extend an opaque backdrop over the gap to the masthead only while pinned.
export default class extends Controller {
  static values = { offset: { type: Number, default: 0 } }

  connect() {
    this.sentinel = document.createElement("div")
    this.sentinel.style.height = "1px"
    this.sentinel.setAttribute("aria-hidden", "true")
    this.element.before(this.sentinel)

    this.observer = new IntersectionObserver(
      ([entry]) => this.element.classList.toggle("is-stuck", entry.intersectionRatio === 0),
      { rootMargin: `-${this.offsetValue}px 0px 0px 0px`, threshold: [0] }
    )
    this.observer.observe(this.sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
    this.sentinel?.remove()
  }
}
